import React from 'react';
import ContentBlock from '../molecules/ContentBlock';

const ContentBlocks = ({ contentBlocks }) => (
  <>
    {contentBlocks.map(contentBlock => (
      <ContentBlock key={contentBlock.id} {...contentBlock} />
    ))}
  </>
);

export default ContentBlocks;
